import { PRE_CANCELLED_STATUS } from 'constants/statusProcess';

import { ERROR_CODES } from 'constants/video/videoselfie';

const formatError = (errorCode = ERROR_CODES.GENERIC_NETWORK_ERROR) => {
    return {
        errorCode,
        status: PRE_CANCELLED_STATUS,
    };
};

export const getErrorFromStartResponse = ({ ok, data }) => {
    if (ok && data && !data.errorCode) return null;
    if (data?.errorCode) return formatError(data.errorCode);

    return formatError(ERROR_CODES.GENERIC_NETWORK_ERROR);
};
